import React from 'react';

import { useIntl } from 'react-intl';

import { Tag, Tooltip } from 'antd';

import { WORK_JOURNEY_STATUS } from '../constants';
import type { WorkJourneyForm } from '../types';

interface WorkJourneyStateProps {
  workJourney: Pick<WorkJourneyForm, 'id' | 'name' | 'state'>;
}

const WorkJourneyState = ({ workJourney }: WorkJourneyStateProps) => {
  const intl = useIntl();

  return (
    <div>
      {workJourney.state === WORK_JOURNEY_STATUS.ACTIVE && (
        <Tag className="gx-mb-0 gx-mr-0" color="success">
          {intl.formatMessage({ id: 'workJourney.state.active' })}
        </Tag>
      )}

      {workJourney.state === WORK_JOURNEY_STATUS.INACTIVE && (
        <Tag className="gx-mb-0 gx-mr-0" color="default">
          {intl.formatMessage({ id: 'workJourney.state.inactive' })}
        </Tag>
      )}

      {workJourney.state === WORK_JOURNEY_STATUS.UPDATED && (
        <Tooltip title={intl.formatMessage({ id: 'workJourney.state.updated.tooltip' })}>
          <Tag className="gx-mb-0 gx-mr-0" color="blue">
            {intl.formatMessage({ id: 'workJourney.state.updated' })}
          </Tag>
        </Tooltip>
      )}

      {workJourney.state === WORK_JOURNEY_STATUS.PENDING && (
        <Tooltip title={intl.formatMessage({ id: 'workJourney.state.pending.tooltip' })}>
          <Tag className="gx-mb-0 gx-mr-0" color="warning">
            {intl.formatMessage({ id: 'workJourney.state.pending' })}
          </Tag>
        </Tooltip>
      )}
    </div>
  );
};

export default WorkJourneyState;
